import { BaseNativeDispatcher } from '../base_native_dispatcher';
import { TokenDispatcherAction } from './token_dispatcher.constants';

export interface TokenMessage {
  action: TokenDispatcherAction;
}

export const tokenDispatcher = new BaseNativeDispatcher<TokenMessage>('tokenHandler');
